module.exports = {
	defaultTitle: 'Siris Technology',
	logo: 'https://portfolio.smakosh.com/favicon/favicon-512.png',
	author: 'Siris Technology',
	url: 'https://siristechnology.com',
	legalName: 'Siris Technology LLC',
	defaultDescription: 'A technology company',
	socialLinks: {
		twitter: 'https://twitter.com/SirisTechnology',
		github: 'https://github.com/siristechnology',
	},
	googleAnalyticsID: 'UA-148889884-1',
	themeColor: '#6b63ff',
	backgroundColor: '#6b63ff',
	social: {
		facebook: 'appId',
		twitter: '@siristechnology',
	},
	address: {
		city: 'CENTREVILLE',
		state: 'VA',
		country: 'USA',
		zipCode: '20121',
	},
	contact: {
		email: 'siristechnologyllc@gmail.com',
	},
	foundingDate: '2019',
	recaptcha_key: '6Lc6bK4UAAAAAEQq5-pPWsB3Ok16n3XiNCYfcAJx',
}
